import { Component, Input, OnChanges, SimpleChanges, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HelpDocumentService } from '../../services/help-document.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-help-attachments',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './help-attachments.component.html',
  styleUrl: './help-attachments.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class HelpAttachmentsComponent implements OnChanges {
  @Input() articleUuid: string | null = null;

  documents: any[] = [];
  caption = '';
  uploading = false;

  private docService = inject(HelpDocumentService);

  private Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2500
  });

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['articleUuid']) {
      this.reload();
    }
  }

  reload(): void {
    if (!this.articleUuid) {
      this.documents = [];
      return;
    }
    this.docService.listByArticle(this.articleUuid).subscribe({
      next: (rows) => (this.documents = rows || []),
      error: () => (this.documents = [])
    });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file || !this.articleUuid) return;
    this.uploading = true;
    this.docService.uploadNew(this.articleUuid, file, this.caption || null).subscribe({
      next: () => {
        this.uploading = false;
        this.caption = '';
        input.value = '';
        this.Toast.fire({ icon: 'success', title: 'Captura subida' });
        this.reload();
      },
      error: (err) => {
        this.uploading = false;
        this.Toast.fire({
          icon: 'error',
          title: err?.error?.error || 'No se pudo subir el archivo'
        });
      }
    });
  }

  viewUrl(row: any): string | null {
    const uuid = row?.document?.uuid || row?.uuid;
    return uuid ? this.docService.viewUrl(uuid) : null;
  }

  insertMarkdownHint(row: any): string {
    const url = this.viewUrl(row);
    const cap = row.caption || 'captura';
    return url ? `![${cap}](${url})` : '';
  }

  copyMd(row: any): void {
    const md = this.insertMarkdownHint(row);
    if (!md) return;
    navigator.clipboard?.writeText(md);
    this.Toast.fire({ icon: 'info', title: 'Markdown copiado' });
  }

  remove(row: any): void {
    Swal.fire({
      title: '¿Eliminar adjunto?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Eliminar'
    }).then((r) => {
      if (!r.isConfirmed) return;
      this.docService.delete(row.uuid).subscribe({
        next: () => {
          this.Toast.fire({ icon: 'success', title: 'Eliminado' });
          this.reload();
        },
        error: (err) => {
          this.Toast.fire({
            icon: 'error',
            title: err?.error?.error || 'No se pudo eliminar'
          });
        }
      });
    });
  }
}
